export default "__VITE_ASSET__79ac697a__"